import HomeNativeCapability from '../home/nativeCapability';
import SrpNativeCapability from '../srp/nativeCapability';
import VdpNativeCapability from '../vdp/nativeCapability';

const NativeCapability = {
  ...HomeNativeCapability,
  ...SrpNativeCapability,
  ...VdpNativeCapability
};

export default NativeCapability;
